var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.aplica)?_c('q-fila',{attrs:{"label":_vm.label,"ayuda":_vm.ayuda,"completa":_vm.respondida,"resaltar":_vm.resaltar}},[_c('input',{staticClass:"form-control",attrs:{"type":"time","disabled":_vm.soloLectura},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value || null)}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }